export const brands = [
  { name: 'Anua', link: '/brand/anua/' },
  { name: 'AHC', link: '/brand/ahc/' },
  { name: 'Beauty of Joseon', link: '/brand/beauty-of-joseon/' },
  { name: 'COSRX', link: '/brand/cosrx/' },
  { name: 'Dr. Jart+', link: '/brand/dr-jart/' },
  { name: 'Dr.G', link: '/brand/dr-g/' },
  { name: 'ETUDE', link: '/brand/etude/' },
  { name: 'Haruharu WONDER', link: '/brand/haruharu-wonder/' },
  { name: 'Holika Holika', link: '/brand/holika-holika/' },
  { name: 'ILLIYOON', link: '/brand/illiyoon/' },
  { name: 'INNISFREE', link: '/brand/innisfree/' },
  { name: 'IOPE', link: '/brand/iope/' },
  { name: 'Isntree', link: '/brand/isntree/' },
  { name: 'KAHI', link: '/brand/kahi/' },
  { name: 'LANEIGE', link: '/brand/laneige/' },
  { name: 'MAY COOP', link: '/brand/may-coop/' },
  { name: 'MEDIHEAL', link: '/brand/mediheal/' },
  { name: 'MISSHA', link: '/brand/missha/' },
  { name: 'Pyunkang Yul', link: '/brand/pyunkang-yul/' },
  { name: 'ROUND LAB', link: '/brand/round-lab/' },
  { name: 'SIDMOOL', link: '/brand/sidmool/' },
  { name: 'SKIN1004', link: '/brand/skin1004/' },
  { name: 'SKINFOOD', link: '/brand/skinfood/' },
  { name: 'SOME BY MI', link: '/brand/some-by-mi/' },
  { name: 'Sulwhasoo', link: '/brand/sulwhasoo/' },
  { name: 'TONYMOLY', link: '/brand/tonymoly/' },
  { name: 'Torriden', link: '/brand/torriden/' },
  { name: '1.618', link: '/brand/1-618/' },
  { name: 'Angel', link: '/brand/angel/' },
  { name: 'BELLAMONSTER', link: '/brand/bellamonster/' },
];

export const moreBrands = { name: 'View More Brands', link: '/brand/' };
